import React from 'react';
import Drawer from 'components/shared/Drawer';
import { List, ListItem, ListItemText, Box } from '@material-ui/core';
import NoAvailableData from 'components/Dashboard/components/NoAvailableData';
import Button from 'components/shared/Button';
import { REPORT_TYPE } from 'constants/constantVariables';

const MonitoringChangesDrawer = ({ open, onClose, title, items = [], applicationId, entityUuid, entityType, searchId, reportType, history }) => {

    const handleGoToUccHistory = () => {
        onClose();
        history.push(
            `/applicant/${applicationId}?tab=ucc&uccDrawerTab=history&uccEntity=${entityUuid}&uccEntityType=${entityType}&uccSearchId=${searchId}`
        );
    };

    const handleGoToBackgroundReport = () => {
        onClose();
        history.push(
            `/applicant/${applicationId}?tab=bgv&bgvEntity=${entityUuid}&bgvEntityType=${entityType}`
        );
    };

    return (
        <Drawer
            open={open}
            onClose={onClose}
            title={title}
        >
            <div style={{ padding: 16 }}>
                {items.length === 0 ? (
                    <NoAvailableData message="No changes available." />
                ) : (
                    <>
                        <List>
                            {items.map((item, idx) => (
                                <ListItem key={idx} divider>
                                    <ListItemText primary={item} />
                                </ListItem>
                            ))}
                        </List>
                        {applicationId && reportType === REPORT_TYPE.UCC && (
                            <Box sx={{ marginTop: '1rem', textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleGoToUccHistory}
                                >
                                    Review Detected Changes in Application
                                </Button>
                            </Box>
                        )}
                        {applicationId && reportType === REPORT_TYPE.LEXIS_BACKGROUND && (
                            <Box sx={{ marginTop: '1rem', textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleGoToBackgroundReport}
                                >
                                    View Background Report in Application
                                </Button>
                            </Box>
                        )}
                    </>
                )}
            </div>
        </Drawer>
    );
};

export default MonitoringChangesDrawer;